import { IconComponentProps } from './index'

const IconAddWidget = ({
  width = 47,
  height = 32,
  color = 'currentColor',
  customClass
}: IconComponentProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 47 32'
    xmlns='http://www.w3.org/2000/svg'
    fill={color}
    className={customClass}
  >
    <path
      d='M0 4C0 1.79086 1.79086 0 4 0H33.8959C35.2131 0 36.4458 0.648468 37.192 1.73388L47 16L37.192 30.2661C36.4458 31.3515 35.2131 32 33.8959 32H4C1.79086 32 0 30.2091 0 28V4Z'
      fill='currentColor'
    />
    <path
      d='M0.5 4C0.5 2.067 2.067 0.5 4 0.5H33.8959C35.0484 0.5 36.1271 1.06741 36.78 2.01715L46.3932 16L36.78 29.9829C36.1271 30.9326 35.0484 31.5 33.8959 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z'
      stroke='black'
      stroke-opacity='0.2'
    />
    <path d='M27 17H21V23H19V17H13V15H19V9H21V15H27V17Z' fill='white' />
  </svg>
)

export default IconAddWidget
